<template>
    <div class="assignment-wrapper">
        <div class="assignment-container">
            <div class="assignment-main">
                <div class="assignee-block">
                    <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                            <v-icon small class="info-icon" v-bind="attrs" v-on="on">
                                mdi-information-outline
                            </v-icon>
                        </template>
                        <span>Operador responsável pelo atendimento desta reserva</span>
                    </v-tooltip>
                    <v-tooltip bottom :disabled="!isAssignmentLocked">
                        <template #activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" style="display: block; min-width: 0; flex: 1;">
                    <button
                        type="button"
                        class="assignee-button rounded-lg"
                        :disabled="isAssignmentLocked"
                        @click="openAssignOtherDialog"
                    >
                        <v-icon small class="assignee-icon">
                            {{ currentAssignee ? 'mdi-account-circle-outline' : 'mdi-account-off-outline' }}
                        </v-icon>
                        <span :class="[currentAssignee ? 'assignee-name' : 'no-assignee', { 'assignee-text--locked': isAssignmentLocked }]">
                            {{ currentAssignee ? currentAssignee.name : 'Sem atuante' }}
                        </span>
                        <v-icon x-small class="edit-icon">mdi-pencil-outline</v-icon>
                    </button>
                            </span>
                        </template>
                        <span>Atribuição bloqueada: reserva fora do status pendente</span>
                    </v-tooltip>
                </div>

                <div class="assignment-actions">
                    <v-tooltip bottom :disabled="!isAssignmentLocked">
                        <template #activator="{ on, attrs }">
                            <span v-if="!isAssignedToViewer && !isPendingWithoutAssignee" v-bind="attrs" v-on="on">
                                <v-btn
                                    small
                                    outlined
                                    color="primary"
                                    :loading="loading"
                                    :disabled="isAssignmentLocked"
                                    @click="assignToMe"
                                    class="action-btn action-btn-primary rounded-lg"
                                >
                                    Atribuir a mim
                                </v-btn>
                            </span>
                        </template>
                        <span>Atribuição bloqueada: reserva fora do status pendente</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                            <v-btn
                                icon
                                small
                                class="assignment-icon-btn"
                                v-bind="attrs"
                                v-on="on"
                                @click="historyDialog = true"
                            >
                                <v-icon class="assignment-action-icon">mdi-history</v-icon>
                            </v-btn>
                        </template>
                        <span>Ver histórico</span>
                    </v-tooltip>

                    <v-tooltip v-if="currentAssignee" bottom>
                        <template #activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-btn
                                    icon
                                    small
                                    class="assignment-icon-btn"
                                    :loading="loading"
                                    :disabled="isAssignmentLocked"
                                    @click="remove"
                                >
                                    <v-icon class="assignment-action-icon">mdi-close</v-icon>
                                </v-btn>
                            </span>
                        </template>
                        <span>{{ isAssignmentLocked ? 'Atribuição bloqueada: reserva fora do status pendente' : 'Remover atuante' }}</span>
                    </v-tooltip>
                </div>
            </div>
        </div>

        <v-dialog v-model="assignOtherDialog" max-width="500" persistent>
            <v-card>
                <v-card-title class="headline">Atribuir responsável</v-card-title>
                <v-card-text>
                    <assign-user-autocomplete
                        v-model="selectedUserId"
                        :exclude-user-id="currentAssigneeId"
                        :no-assignee-option="true"
                        label="Buscar por nome ou email"
                        placeholder="Digite para buscar..."
                        :hide-details="false"
                        @select="onUserSelected"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text :disabled="loading" @click="closeAssignOtherDialog">Cancelar</v-btn>
                    <v-btn
                        color="primary"
                        :loading="loading"
                        :disabled="!selectedUser"
                        @click="assignToSelectedUser"
                    >
                        Atribuir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <booking-assignment-history-dialog
            v-model="historyDialog"
            :booking-id="booking.id"
        />
    </div>
</template>

<script>
import AssignUserAutocomplete from './AssignUserAutocomplete.vue';
import BookingAssignmentHistoryDialog from './BookingAssignmentHistoryDialog.vue';

export default {
    name: 'BookingAssignmentCard',

    components: {
        AssignUserAutocomplete,
        BookingAssignmentHistoryDialog,
    },

    props: {
        booking: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            historyDialog: false,
            assignOtherDialog: false,
            selectedUserId: null,
            selectedUser: null,
        };
    },

    computed: {
        currentAssignee() {
            return this.booking.current_assignee || null;
        },
        currentAssigneeId() {
            return this.currentAssignee ? this.currentAssignee.id : null;
        },
        isAssignedToViewer() {
            return this.booking.is_assigned_to_viewer;
        },
        isAssignmentLocked() {
            return this.booking.status !== 'pending';
        },
        isPendingWithoutAssignee() {
            return this.booking.status === 'pending' && !this.booking.current_assignee;
        }
    },

    methods: {
        async assignToMe() {
            await this.callAssign({ user_id: null }, 'Atribuído a você.');
        },
        async assignToSelectedUser() {
            if (!this.selectedUser) return;

            if (this.selectedUser.id === 'null') {
                await this.remove();
                this.closeAssignOtherDialog();
                return;
            }

            await this.callAssign(
                { user_id: this.selectedUser.id },
                `Atribuído a ${this.selectedUser.name}.`
            );
            this.closeAssignOtherDialog();
        },
        async callAssign(payload, successMessage) {
            try {
                this.loading = true;
                await axios.post(`/api/booking/${this.booking.id}/assignment`, payload);
                this.$simpleDialog(successMessage, 'success');
                this.$emit('updated');
            } catch (e) {
                this.$simpleDialog('Erro ao atribuir responsável.', 'error');
            } finally {
                this.loading = false;
            }
        },
        async remove() {
            try {
                this.loading = true;
                await axios.delete(`/api/booking/${this.booking.id}/assignment`);
                this.$simpleDialog('Responsável removido com sucesso.', 'success');
                this.$emit('updated');
            } catch (e) {
                this.$simpleDialog('Erro ao remover responsável.', 'error');
            } finally {
                this.loading = false;
            }
        },
        openAssignOtherDialog() {
            this.assignOtherDialog = true;
        },
        onUserSelected(user) {
            this.selectedUser = user;
        },
        closeAssignOtherDialog() {
            this.assignOtherDialog = false;
            this.selectedUserId = null;
            this.selectedUser = null;
        },
    },
};
</script>

<style scoped lang="scss">
.assignment-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.section-title {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0;
    font-size: 10px;
    font-weight: 600;
    color: #9e9e9e;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    line-height: 1.4;

    .info-icon {
        font-size: 13px !important;
        color: #bdbdbd;
        cursor: help;
        transition: color 0.2s ease;

        &:hover {
            color: #888;
        }
    }
}

.assignment-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.assignment-main {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
}

.assignee-block {
    min-width: 0;
    flex: 0 1 350px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
}

.label {
    margin-bottom: 4px;
    font-size: 11px;
    color: #757575;
    font-weight: 500;
    text-transform: uppercase;
}

.assignee-button {
    width: 100%;
    min-height: 28px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border: 1px solid #f0f0f0;
    background: #fafafa;
    color: #1a1a1a;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
    transition: all 0.15s ease;

    &:hover {
        border-color: #bbdefb;
        background-color: #f5fbff;

        .assignee-icon,
        .edit-icon {
            color: #2196f3;
        }
    }

    &:disabled {
        cursor: default;
        pointer-events: none;
        background: #f5f5f5;
        border-color: #e0e0e0;

        .assignee-icon,
        .edit-icon {
            opacity: 0.4;
        }
    }

}

.assignee-icon {
    color: #607d8b;
    flex: 0 0 auto;
}

.assignee-name,
.no-assignee {
    min-width: 0;
    flex: 1;
    font-size: 13px;
    line-height: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.assignee-name {
    font-weight: 500;
}

.no-assignee {
    color: #757575;
}

.assignee-text--locked {
    font-weight: 500 !important;
}

.edit-icon {
    color: #607d8b;
    transition: color 0.2s ease;
    flex: 0 0 auto;
}

.assignment-actions {
    display: flex;
    align-items: center;
    gap: 2px;
    flex: 0 0 auto;
    height: 28px;
}

.assignment-icon-btn {
    width: 28px;
    height: 28px;
}

.assignment-action-icon {
    font-size: 18px !important;
}

.action-btn {
    min-width: 0;
    height: 28px;
    padding: 0 8px;
    text-transform: none;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;

    &.action-btn-primary {
        border-color: #2196f3;

        &.v-btn--disabled {
            border-color: rgba(0, 0, 0, 0.26) !important;
        }
    }

    ::v-deep .v-btn__content {
        font-size: 12px;
        font-weight: 500;
    }
}
</style>
